import { KpiCard } from "@vantage-hub/ui";

const YEAR_SPARK = [520, 545, 580, 620, 655, 690, 710, 735, 760, 800, 840, 884];
const MONTH_SPARK = [98, 105, 112, 108, 119, 124, 131, 127, 135, 138, 140, 142];
const APPROVAL_SPARK = [12, 14, 11, 16, 13, 15, 17, 14, 16, 19, 17, 18];
const EXPIRING_SPARK = [38, 42, 35, 48, 44, 51, 55, 49, 58, 62, 67, 72];

export function CertKpiSection() {
	return (
		<div className="mb-5 grid grid-cols-4 gap-5">
			<KpiCard
				featured
				label="Generated This Year"
				value="1,284"
				delta="+68 vs last year"
				deltaDir="up"
				foot="All programs · 2026"
				sparkData={YEAR_SPARK}
				sparkColor="var(--color-secondary)"
			/>
			<KpiCard
				label="Generated This Month"
				value="142"
				delta="+12 vs last month"
				deltaDir="up"
				foot="April 2026"
				sparkData={MONTH_SPARK}
				sparkColor="var(--color-primary)"
			/>
			<KpiCard
				label="Waiting for Approval"
				value="18"
				delta="5 new today"
				deltaDir="up"
				foot="Pending review"
				sparkData={APPROVAL_SPARK}
				sparkColor="#E8A93B"
			/>
			<KpiCard
				label="Expiring in 30 Days"
				value="72"
				delta="12 new"
				deltaDir="up"
				foot="Across 6 programs"
				sparkData={EXPIRING_SPARK}
				sparkColor="#D26A6A"
			/>
		</div>
	);
}
